import { motion } from "framer-motion";
import { Brush, Home, Wrench, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Home,
    title: "Exterior Painting",
    body: "Homes, storefronts, warehouses. Weatherproof finishes that hold up under Alabama sun.",
    tag: "01",
  },
  {
    icon: Brush,
    title: "Interior Painting",
    body: "Rooms, offices, trim, cabinets, accent walls. Crisp lines and premium paint.",
    tag: "02",
  },
  {
    icon: Wrench,
    title: "Other Construction",
    body: "Drywall, trim carpentry, patching, prep work, pressure washing — ask us.",
    tag: "03",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-40 border-t border-brand-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="text-[11px] tracking-[0.3em] uppercase text-brand-muted mb-4 flex items-center gap-3">
          <span className="h-px w-8 bg-brand-blue" />
          What We Do
        </div>
        <h2 className="font-display uppercase text-6xl md:text-8xl leading-[0.9] mb-6 max-w-4xl">
          Residential <span className="text-brand-blue">&</span> Commercial.
        </h2>
        <p className="sr-only">
          Best Residential Exterior Painting Services, Professional Interior Painters,
          and General Construction in Montgomery, AL and surrounding areas.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border border-brand-border mt-14 md:mt-20">
          {SERVICES.map((s, i) => (
            <motion.a
              href="#lead-form"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("lead-form")?.scrollIntoView({ behavior: "smooth" });
              }}
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              data-testid={`service-${i}`}
              className={`group relative p-8 md:p-12 flex flex-col gap-6 min-h-[380px] cursor-pointer bg-brand-bg hover:bg-brand-blue transition-colors duration-500 ${
                i < SERVICES.length - 1 ? "border-b md:border-b-0 md:border-r border-brand-border" : ""
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="font-display text-brand-muted text-xl tracking-widest group-hover:text-white transition-colors">
                  {s.tag}
                </span>
                <ArrowUpRight className="h-6 w-6 text-brand-muted group-hover:text-white group-hover:rotate-45 transition-all duration-500" />
              </div>
              <s.icon className="h-10 w-10 text-brand-blue group-hover:text-white transition-colors" strokeWidth={1.5} />
              <h3 className="font-display uppercase text-3xl md:text-4xl leading-none">
                {s.title}
              </h3>
              <p className="text-brand-muted group-hover:text-white/90 text-sm md:text-base transition-colors">
                {s.body}
              </p>
              <div className="mt-auto text-[10px] tracking-[0.3em] uppercase text-brand-muted group-hover:text-white transition-colors">
                Request a quote →
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
